module.exports = __webpack_public_path__ + "static/Q6Answer2_Beingignored_ClemOnojeghuo-9edbd31d5dc0d5d61070fcdff5ac199b.jpg";